"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformExpiryDate = void 0;
/**
 * Transforms a string in MM/YYYY format into a Date object.
 *
 * @param originalValue - The original value to transform.
 * @returns A Date object or an empty string.
 */
const transformExpiryDate = (originalValue) => {
    if (!originalValue || originalValue instanceof Date) {
        return '';
    }
    const month = originalValue === null || originalValue === void 0 ? void 0 : originalValue.split("/")[0];
    const year = originalValue === null || originalValue === void 0 ? void 0 : originalValue.split("/")[1];
    // Create a date object for the current date without the time part
    return new Date(`${month}/1/${year}`);
};
exports.transformExpiryDate = transformExpiryDate;
